<script lang="ts">
import { defineComponent } from 'vue';
import { buildRefLink } from '@/shared/lib/core/referral';
import { projectName } from '@/shared/constants/system';
import { useUserStore } from '@/shared/store/useUserStore';
import { useSentryAsync } from '@/shared/composition/useSentryAsync';

const { captureExceptionSentry } = useSentryAsync();

export default defineComponent({
  name: 'AppPopupInvitation',
  data: () => ({}),
  computed: {
    cardHash() {
      const userStore = useUserStore();
      return userStore.getUserInfo?.physicalUserCard?.cardHash;
    },
    refLink() {
      if (!this.cardHash) return '';

      return buildRefLink(this.cardHash, projectName);
    },
  },
  methods: {
    async copyLink() {
      try {
        const { container } = this.$refs;
        await this.$copyText(this.refLink, container);
        alert(this.$t('homepage.linkCopied'));
      } catch (error) {
        captureExceptionSentry(error, 'Попап инвайта копирование ссылки мти');
      }
    },
    invitePage() {
      this.$router.push('/invite');
      this.$emit('close', false);
    },
  },
});
</script>
